import useSWR from "swr";
import { API_BASE_URL } from "@/lib/env";
import type { CreditGrantSummary } from "@/api/client";

interface FetchError extends Error {
  status?: number;
}

export function useCredits() {
  const { data, error, isLoading, mutate } = useSWR<CreditGrantSummary>(
    `${API_BASE_URL}/me/credit-grant-summary`,
    {
      revalidateIfStale: false,
      onErrorRetry: (err: FetchError) => {
        // Don't retry 404s (endpoint may not exist for some plans)
        if (err.status === 404) return;
      },
    },
  );

  return {
    creditBalance: data?.balance_cents ?? null,
    isLoading,
    isError: !!error,
    refreshCredits: mutate,
  };
}
